import { createContext, useContext, useEffect, useState } from 'react';

const INITIAL_STATE = {
  darkTheme: true,
};

const ThemeContext = createContext(INITIAL_STATE);
const ThemeUpdateContext = createContext();

export function useTheme() {
  return useContext(ThemeContext);
}

export function useThemeUpdate() {
  return useContext(ThemeUpdateContext);
}

export const ThemeProvider = ({ children }) => {
  const [darkTheme, setDarkTheme] = useState(INITIAL_STATE.darkTheme);

  useEffect(() => {
    const savedTheme = localStorage.getItem('darkTheme');
    if (savedTheme !== null) {
      setDarkTheme(JSON.parse(savedTheme));
    }
    // else {
    //   // Set theme based on local time: dark from 7pm to 7am, light otherwise
    //   const hour = new Date().getHours();
    //   if (hour >= 19 || hour < 7) {
    //     setDarkTheme(true); // Dark theme
    //   } else {
    //     setDarkTheme(false); // Light theme
    //   }
    // }
  }, []);

  useEffect(() => {
    localStorage.setItem('darkTheme', JSON.stringify(darkTheme));
  }, [darkTheme]);

  function toggleTheme() {
    setDarkTheme((prevDarkTheme) => !prevDarkTheme);
  }

  return (
    <ThemeContext.Provider value={{ darkTheme }}>
      <ThemeUpdateContext.Provider value={toggleTheme}>
        {children}
      </ThemeUpdateContext.Provider>
    </ThemeContext.Provider>
  );
};
